import React from "react";
import { FAQS } from "@/data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel, CTAButton, requestInquiry } from "@/components/site/ui";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-36 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionLabel>FAQ</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-heading font-bold text-charcoal text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Questions, answered.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              Still unsure? Reach out and we&rsquo;ll provide clear, personalized guidance
              for your situation.
            </p>
            <div className="mt-8">
              <CTAButton
                testid="faq-contact-btn"
                variant="dark"
                onClick={() => requestInquiry("contact")}
                className="!py-3 !px-6"
              >
                Contact Us
              </CTAButton>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-black/10"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-heading text-lg sm:text-xl text-charcoal hover:text-crimson hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6 pr-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
